// src/layouts/DefaultLayout/DefaultLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import { Header, Footer } from "../../components";

export default function DefaultLayout() {
  return (
    <>
      {/* Bootstrap 5 uses visually-hidden */}
      <a href="#main-content" className="visually-hidden-focusable">
        Skip to main content
      </a>

      <Header />

      <main id="main-content" role="main">
        <Outlet />
      </main>

      <Footer />
    </>
  );
}
